module.exports = __webpack_public_path__ + "img/slika7.52f291e6.jpg";